import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_121_add_parts_return: any[] = [
  {
      "componentType": "screenGroup",
      "title": "Parts return",
      "screenId": "121",
      "childComponents": [
          {
              "componentType": "form",
              "Name": "parts_return",
              "TableName": "service_spare_part_return",
              "Plugins": [
                  {
                      "type": "api"
                  }
              ],
              "columnNumber": "m1 t1 w1",
              "Fields": [
                  {
                      "componentType": "fieldGroup",
                      "Label": "Parts return details",
                      "BindValue": "con_parts_return_details",
                      "style": {
                          "direction": "column"
                      },
                      "childComponents": [
                          {
                              "componentType": "textField",
                              "name": "txt_return_no",
                              "label": "Return no#",
                              "placeholder": "This will be auto populate...",
                              "required": false,
                              "inputType": "text",
                              "Json_Attribute": "return_no",
                              "IsReadOnly": true,
                              "AutoPopulate": true,
                              "AutoPopulate_format": "PRN_[******]",
                              "BindValue": "txt_return_no"
                          },
                          {
                              "componentType": "dateField",
                              "name": "txt_returndate",
                              "label": "Return date",
                              "placeholder": "Return date",
                              "DefaultToday": true,
                              "required": true,
                              "Json_Attribute": "return_date",
                              "validation": [
                                  {
                                      "rule": "required",
                                      "message": "Return date is required"
                                  }
                              ],
                              "BindValue": "txt_returndate"
                          },
                          {
                              "componentType": "searchableDropdown",
                              "name": "issue_no",
                              "label": "Issue no",
                              "placeholder": "",
                              "required": true,
                              "lookupName": "issued_Spareparts",
                              "options": [],
                              "searchable": true,
                              "clearable": true,
                              "Json_Attribute": "issue_id",
                              "validation": [
                                  {
                                      "rule": "required",
                                      "message": "Issue no is required"
                                  }
                              ],
                              "BindValue": "issue_no"
                          }
                      ]
                  },
                  {
                      "componentType": "subModule",
                      "name": "sub_Checklist",
                      "label": "Part details",
                      "tableName": "service_spare_parts_return_details",
                      "lookupName": "issued_Spareparts_details",
                      "parentField": "issue_no",
                      "BindValue": "sub_checklist",
                      "childControls": [
                          {
                              "componentType": "selectDropdown",
                              "name": "drp_code",
                              "label": "Code",
                              "placeholder": "",
                              "required": false,
                              "lookupName": "issued_Spareparts_details",
                              "parentField": "issue_no",
                              "options": [],
                              "Json_Attribute": "codeid",
                              "BindValue": "drp_code"
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_itemname",
                              "label": "Item name",
                              "placeholder": "",
                              "required": false,
                              "inputType": "text",
                              "Json_Attribute": "item_name",
                              "disabled": true,
                              "BindParent": {
                                  "drp_code": "item_name"
                              }
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_already_returned_qty",
                              "label": "Already returned qty.",
                              "placeholder": "",
                              "required": false,
                              "inputType": "number",
                              "defaultValue": "0",
                              "Json_Attribute": "already_returned_qty",
                              "disabled": true,
                              "ExcludeFromSave": true,
                              "BindValue": "txt_already_returned_qty"
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_qty",
                              "label": "Issued qty.",
                              "placeholder": "",
                              "required": false,
                              "inputType": "number",
                              "defaultValue": "0",
                              "Json_Attribute": "qty",
                              "BindValue": "txt_qty",
                              "disabled": true,
                              "validation": [
                                  {
                                      "rule": "condition",
                                      "condition": "[qty] >= ([already_returned_qty] + [return_qty])",
                                      "message": "Return quantity should be less or equal to remaining issued quantity"
                                  }
                              ]
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_return_qty",
                              "label": "Return qty",
                              "placeholder": "",
                              "required": false,
                              "inputType": "number",
                              "defaultValue": "0",
                              "Json_Attribute": "return_qty",
                              "BindValue": "txt_return_qty",
                              "validation": [
                                  {
                                      "rule": "pattern",
                                      "value": "^[0-9]*$",
                                      "message": "Only numbers are allowed"
                                  },
                                  {
                                      "rule": "condition",
                                      "condition": "[return_qty] <= ([qty] - [already_returned_qty])",
                                      "message": "Return quantity should not be greater than remaining balance",
                                      "isWarning": true
                                  }
                              ]
                          },
                          {
                              "componentType": "batchAllocation",
                              "name": "return_batch_allocation",
                              "label": "Return Batch Allocation",
                              "metadataParentField": "product_id",
                              "metadataLookupName": "product_batch_by_product",
                              "issueQtyField": "txt_return_qty",
                              "BindValue": "return_batch_allocation",
                              "Json_Attribute": "batch_allocation"
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_balance_qty",
                              "label": "Balance qty.",
                              "placeholder": "",
                              "required": false,
                              "inputType": "number",
                              "defaultValue": "0",
                              "BindValue": "txt_balance_qty",
                              "Json_Attribute": "bal_return_qty",
                              "disabled": true,
                              "ExcludeFromSave": true,
                              "ForceExpressionUpdate": true,
                              "ExpressionV2": "[txt_qty] - [txt_already_returned_qty] - [txt_return_qty]"
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_rate",
                              "label": "Rate",
                              "placeholder": "",
                              "required": false,
                              "inputType": "number",
                              "defaultValue": "0",
                              "Json_Attribute": "rate",
                              "BindValue": "txt_rate",
                              "disabled": true
                          },
                          {
                              "componentType": "textField",
                              "name": "txt_amount",
                              "label": "Amount",
                              "placeholder": "",
                              "IsMandatory": true,
                              "required": false,
                              "inputType": "number",
                              "defaultValue": "0",
                              "Json_Attribute": "amount",
                              "BindValue": "txt_amount",
                              "disabled": true,
                              "ForceExpressionUpdate": true,
                              "ExpressionV2": "([txt_return_qty] > 0 ? ([return_batch_allocation.total] > 0 ? [return_batch_allocation.total] : ([txt_return_qty] * [txt_rate])) : 0)",
                              "validation": [
                                  {
                                      "rule": "pattern",
                                      "value": "^(?!0+(?:\\.0+)?$)\\d+(?:\\.\\d+)?$",
                                      "message": "Amount should be greater than zero"
                                  }
                              ]
                          }
                      ]
                  }
              ]
          },
          {
              "componentType": "button",
              "name": "Submit",
              "onPressAction": "save",
              "style": {
                  "backgroundColor": "#22c55e"
              }
          }
      ]
  }
];
